import React, { useState } from "react";
import { Icon } from "antd";

const StatTabCard = ({ icon, label, tabs, values, format }) => {
  const [active, setActive] = useState(tabs[0].key);
  const value = values[active];

  return (
    <div className="statCard">
      <div className="statCard__top">
        <span className="statCard__icon">
          <Icon type={icon} />
        </span>
        <div className="statCard__tabs">
          {tabs.map((tb) => (
            <button
              key={tb.key}
              type="button"
              className={`statCard__tab${active === tb.key ? " statCard__tab--active" : ""}`}
              onClick={() => setActive(tb.key)}
            >
              {tb.label}
            </button>
          ))}
        </div>
      </div>
      <div className="statCard__bottom">
        <span className="statCard__label">{label}</span>
        <span className="statCard__value">{format ? format(value) : value}</span>
      </div>
    </div>
  );
};

export default StatTabCard;
